import React from "react";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import { useStoreSelector, useStoreDispatch } from "../../store/Hooks";
import { navSliceActions } from "../../store/slices/NavSlice";
import AnchorTable from "../patients/AnchorTable";
import Anchor from "../../models/anchors/Anchor";

const Patients = () => {
  const dispatch = useStoreDispatch();
  const interaction_id = useStoreSelector(
    (state) => state.interactionTree.RootInteractionID,
  );
  const createAnchor = () => {
    const anchor = new Anchor();
    anchor.update("interaction_id", interaction_id);
    dispatch(
      navSliceActions.openRightDrawer({
        type: "anchor",
        resourceID: anchor.id,
      }),
    );
  };
  return (
    <Box textAlign="center" padding="10px">
      <AnchorTable />
      {interaction_id > 0 && interaction_id !== null && (
        <Button onClick={createAnchor}>Create Anchor</Button>
      )}
    </Box>
  );
};

export default Patients;
